<template>
  <span>
    <aha-button
      :disabled="isResetResultsButtonDisabled"
      variant="white horizontal layout center"
      @click="isClearDataConfirmationModalShowing = true"
      class="clear-response-bigger"
      v-tooltip="hideTooltip ? '' : tooltipText"
    >
      <aha-icon name="reset" />
      <span>Reset results</span>
    </aha-button>

    <modal-clear-data
      v-if="isClearDataConfirmationModalShowing"
      :title="modalHeading"
      :presentation="$store.state.presentation"
      :clear-data-handler="clearData"
      @hide="isClearDataConfirmationModalShowing = false"
    />
  </span>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import ModalClearData from '@/components-v2/modals/ClearData.vue'
import Config from '@/config'
import Utils from '@/util'
import constants from '@/constant'
import EventBus from '@/eventBus'

const { gaCategories } = constants

export default {
  components: {
    ModalClearData,
  },
  props: {
    hideTooltip: {
      type: Boolean,
      default: false,
    },
    gaAction: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isClearDataConfirmationModalShowing: false,
      loadingClearData: false,
    }
  },

  computed: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapState({
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    modalHeading() {
      return `Reset '${this.presentation.name}'?`
    },
    isResetResultsButtonDisabled() {
      return this.isDisableEditPresentation || !this.presentation.hasResults
    },
    tooltipText() {
      return '<p>You can delete all the <b>votes</b>, <b>submissions</b> and <b>reactions</b>.</p>'
    },
    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
  },

  methods: {
    ...mapActions('presentationReport', [
      'clearPresentationReportAction',
    ]),
    ...mapActions(['patchPresentationAction']),
    async clearData() {
      if (this.loadingClearData) return

      this.loadingClearData = true

      const {
        id: presentationId, uniqueAccessCode, teamPlay,
      }
        = this.presentation

      const payload = {
        id: presentationId,
      }
      if (teamPlay) {
        payload.uniqueAccessCode = uniqueAccessCode
        payload.teamPlay = teamPlay
      }

      try {
        await this.$http.post(Config.api.clearAudienceData, payload)
        this.patchPresentationAction({
          hasResults: false,
        })
      } catch (error) {
        const errorMsg = JSON.stringify(error)
        Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Results menu > Clear Audience data > Failed', errorMsg)

        throw error
      } finally {
        this.loadingClearData = false
        this.isClearDataConfirmationModalShowing = false
        this.patchPresentationAction({
          submitSlideLookup: null,
        })
      }

      this.clearPresentationReportAction()
      this.$store.dispatch('updatePresentation', {
        exportData: {
          ...this.presentation,
          reportUrl: null,
          reportStatus: null,
          reportUpdatedAt: null,
        },
      })

      this.$store.state.presentation.slides.forEach((slide) => {
        if (slide.type === 'openEnded' || slide.type === 'wordCloud' || slide.type === 'ideas') {
          slide.SlideOptions = []
        }
        if (slide.type === 'spinnerWheel') {
          EventBus.$emit('clearSpinnerWheel', slide.id)
          slide.metadata = {
            ...slide.metadata,
            winner: null,
            entries: null,
            entryUrl: null,
            wheelStatus: null,
          }
        }

        if (slide.type === 'multipleChoice' || slide.type === 'pickAnswer' || slide.type === 'imageChoice') {
          slide.SlideOptions.forEach((slideOption) => {
            slideOption.count = 0
          })
        }
        slide.multipleCountAnswer = 0
        slide.votingStep = constants.IdeasTabName.SUBMISSION
      })

      this.$store.state.audiences = {}
      this.$store.state.countPlayer = 0

      const index = this.$store.state.presentation.slides.findIndex((item) => {
        return item.id === this.$store.state.slideActive.id
      })

      this.$store.dispatch('updateSlideActive', { id: null, activeTab: null })
      setTimeout(() => {
        this.$store.dispatch(
          'setSlideActive',
          JSON.parse(JSON.stringify(this.$store.state.presentation.slides[index])),
        )
      }, 0)
      this.$store.state.questions = []
      this.$store.state.audiences = {}
      this.$store.state.tabQnaQuestion = 1
      this.$store.state.lastQuestion = {}
      this.$store.state.questionCount = 0
      this.$store.state.presentation.showExport = false
      this.$store.state.countTopQuestion = 0
      this.$store.state.countPinnedQuestion = 0
      this.$store.state.countAnswerQuestion = 0
      this.$store.state.presentation.numberOfHearts = 0
      this.$store.state.presentation.numberOfLaughs = 0
      this.$store.state.presentation.numberOfLikes = 0
      this.$store.state.presentation.numberOfSads = 0
      this.$store.state.presentation.numberOfWows = 0

      if (!this.presentation.hasExampleResponses) {
        Utils.showToastSuccess('Reset all results')
        Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, `${this.gaAction} > Clear Audience data > Success`)
      } else {
        Utils.showToastSuccess('Reset all results')
        Utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, `${this.gaAction} > Clear Example data > Success`)
      }

      if (this.$store.state.presentation.teamData) {
        this.$store.state.presentation.teamData.forEach((team) => {
          team.teams = []
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.clear-response-bigger {
  height: 36px;
}
</style>
